export interface IBaseLayerPlaceholder {
  id: string;
  styleUrl: string;
  label: string;
  description: string;
}

export const BASELAYERS: IBaseLayerPlaceholder[] = [
  {
    id: 'mapbox-basic',
    styleUrl: 'mapbox://styles/cedricversluys/cmrkymsva000801s64dd8ewpz',
    label: 'Basic',
    description:
      'Subtle basemap displaying only the most relevant features for orientation on the map, focusing on recognizability for a broad audience.',
  },
  {
    id: 'mapbox-streets',
    styleUrl: 'mapbox://styles/cedricversluys/cki7ida3w0ok919pbekhoqmbp',
    label: 'Streets',
    description:
      'Detailed basemap emphasizing road and transit networks of a wide variety of transport modes using bright colors, ensuring a quick understanding of road hierarchies and classifications.',
  },
  // {
  //   id: 'mapbox-outdoors',
  //   styleUrl: 'mapbox://styles/cedricversluys/cklgmfd9g12y617qsbp9d5m8p',
  //   label: 'Outdoors',
  //   description:
  //     'Detailed basemap displaying natural and topographical features while emphasizing hiking and biking networks, providing a complete context for adventurous data to be displayed and understood.',
  // },
  // {
  //   id: 'mapbox-spring',
  //   styleUrl: 'mapbox://styles/cedricversluys/cksgibkcxnswk17pl3xqoijse',
  //   label: 'Spring',
  //   description:
  //     'Subtle basemap displaying only the most relevant features for orientation on the map in soft colors while emphasizing walking and biking networks, facilitating full focus on walking and cycling data on the map.',
  // },
  {
    id: 'mapbox-light',
    styleUrl: 'mapbox://styles/cedricversluys/ckficu3vp0lpb19s2eod7eitn',
    label: 'Light',
    description:
      'Subtle basemap displaying all features on the map in different shades of light grey and white, ensuring no distraction from your own data visualizations.',
  },
  // {
  //   id: 'mapbox-dark',
  //   styleUrl: 'mapbox://styles/cedricversluys/ckpy1e3970mdb18rlrp3ep0w8',
  //   label: 'Dark',
  //   description:
  //     'Subtle basemap displaying all features on the map in different shades of light grey and white, ensuring no distraction from your own data visualizations.',
  // },
  {
    id: 'mapbox-satellite',
    styleUrl: 'mapbox://styles/cedricversluys/ckficuixz09dk19mljp7j9slc',
    label: 'Satellite',
    description:
      'Satellite	imagery basemap displaying satellite and aerial images of the terrain, supplemented by a subtle layer of road and transit networks to facilitate easy orientation on the map.',
  },
];
